module.exports = __webpack_public_path__ + "media/newOrder.b473d19a.mp3";